import Tab from "@components/tabs";
import React from "react";
import TermsAndConditions from "./termsandconditions";
import PrivacyPolicy from "./privacypolicy";
import CancellationPolicy from "./cancellationpolicy";
import About from "./aboutus";
import Header from "@commons/header";
import Column from "@components/column";
import SocialMedia from "./socialmedia";
import { useSearchParams } from "react-router-dom";

const PageSetup = () => {
  const [searchParams] = useSearchParams();
  const groupParam = searchParams.get("group") || "customer";
  // Always work with lowercase internally for key prefixing
  const selectedGroup = groupParam.toLowerCase();

  const groups = [
    { label: "customer", value: "customer" },
    { label: "store", value: "store" },
    { label: "delivery", value: "delivery" },
  ];

  const activeGroupIndex = groups.findIndex((g) => g.value === selectedGroup);

  const items = [
    {
      label: "Terms & Conditions",
      component: TermsAndConditions,
      props: { group: selectedGroup },
    },
    {
      label: "Privacy Policy",
      component: PrivacyPolicy,
      props: { group: selectedGroup },
    },
    {
      label: "Cancellation Policy",
      component: CancellationPolicy,
      props: { group: selectedGroup },
    },
    {
      label: "About Us",
      component: About,
      props: { group: selectedGroup },
    },
    { label: "Social Media", component: SocialMedia },
  ];

  return (
    <Column>
      <Header title="Page Setup" />
      <div style={{ marginBottom: "20px", width: "fit-content", textTransform: "capitalize" }}>
        <Tab
          items={groups.map((g) => ({
            label: g.label,
            component: () => null,
          }))}
          activeIndex={activeGroupIndex === -1 ? 0 : activeGroupIndex}
          paramKey="group"
        />
      </div>
      <Tab items={items} />
    </Column>
  );
};

export default PageSetup;
